import { render } from "./SecureUpload.vue?vue&type=template&id=7d4e5809&scoped=true"
import script from "./SecureUpload.vue?vue&type=script&lang=js"
export * from "./SecureUpload.vue?vue&type=script&lang=js"

import "./SecureUpload.vue?vue&type=style&index=0&id=7d4e5809&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4e5809"]])

export default __exports__